/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
// import { useIntl } from 'react-intl'
import { toAbsoluteUrl, KTIcon } from '../../../_metronic/helpers'
import { getPostHome, getAmountHome, getLastBirthdays, getPaymentDates, getImagesBanner, getAmsmConecta, getEvents, getNewsletterFederacion } from '../../Api'
import { setTitlePage, capitalizeWords } from '../../Functions'
import { Link } from 'react-router-dom'
import {useAuth} from '../../modules/auth'
import { Carousel } from 'react-bootstrap'
interface EventProps {
  value: {
    fecha: string;
    prioritario: string;
    evento: string;
    link: string;
  };
}

interface BirthdayProps {
  show: boolean;
  value: {
    fecha: string;
    user: string;
    link: string;
  };
}

const Event: React.FC<EventProps> = (props) => {
  const { value } = props;
  return (
    <div className='timeline-item'>
      <div className='timeline-label text-gray-400 evento'>{value.fecha}</div>
      <div className='timeline-badge'>
        <i className={`fa fa-genderless ${value.prioritario === '1' ? 'text-warning' : 'text-success'} fs-1`}></i>
      </div>
      <div className='fw-mormal timeline-content text-muted ps-3 evento'>
        <a href={value.link} target='blank'>
          {value.evento}
        </a>
      </div>
    </div>
  )
}
const Birthday: React.FC<BirthdayProps> = (props) => {
  const { value, show } = props;
  return (
    <>{show ? (
    <div className="bg-light-warning p-3 text-cumple" style={{ marginBottom: '1rem' }}>
      <div className='row' style={{ marginLeft: '1px' }}>
        <span className='text-gray-400 fecha col' style={{ display: 'contents' }}> {value.fecha} </span>
        <span className='col nombre'> {capitalizeWords(value.user)} </span>
      </div>
    </div>) : (<></>)}</>
  )
}


const DashboardPage: FC = () => {
  const {auth} = useAuth();
  const [posts, setPosts] = useState([]);
  const [events, setEvents] = useState([]);
  const [birthdays, setBirthdays] = useState([]);
  const [paymentDates, setPaymentDates] = useState({
    hmq: '',
    consultas: ''
  });
  const [amsmConecta, setAmsmConecta] = useState({
    amsmconecta: {
      link: ''
    },
  });
  const [newsletterFederacion, setNewsletterFederacion] = useState({
    newsletter_federacion: {
      link: ''
    },
  });
  const [imagesBanner, setImagesBanner] = useState([]);
  const [amount, setAmount] = useState(0);
  const [loadingAmount, setloadingAmount] = useState(true);

  const _getPosts = async () => {
    const _response: any = await getPostHome({});
    if (_response.status) {
      setPosts(_response.data);
    }
  };

  const _getBirthdays = async () => {
    const _response: any = await getLastBirthdays({});
    if (_response.status) {
      setBirthdays(_response.data);
    }
  };
  const _getNewsletterFederacion = async () => {
    const _response: any = await getNewsletterFederacion({});
    if (_response.status) {
      setNewsletterFederacion(_response.data);
    }
  };
  const _getAmsmConecta = async () => {
    const _response: any = await getAmsmConecta({});
    if (_response.status) {
      setAmsmConecta(_response.data);
    }
  };
  const _getEvents = async () => {
    const _response: any = await getEvents({});
    if (_response.status) {
      setEvents(_response.data);
    }
  };
  const _getPaymentDates = async () => {
    const _response: any = await getPaymentDates({});
    if (_response.status) {
      setPaymentDates(_response.data);
    }
  };
  const _getImagesBanner = async () => {
    const _response: any = await getImagesBanner({});
    if (_response.status) {
      setImagesBanner(_response.data.banner);
    }
  };

  const _getAmount = async () => {
    setloadingAmount(true);
    const _response: any = await getAmountHome({});
    if (_response.status) {
      const amountv = _response.data[0].monto ?? 0;
      setAmount(amountv);
    }
    setloadingAmount(false);
  }

  const handleClickOnElement = () => {
    setTimeout(() => {
      const elementToClick = document.querySelector('[data-bs-target="#kt_carousel_2_carousel"][data-bs-slide-to="0"]');
      if (elementToClick instanceof HTMLElement) {
        elementToClick.click();
      }
    }, 2000);
  };

  useEffect(() => {
    _getPaymentDates();
    _getPosts();
    _getAmount();
    _getBirthdays();
    _getImagesBanner();
    _getAmsmConecta();
    _getNewsletterFederacion();
    _getEvents();
    handleClickOnElement();
  }, []);

  return (
    <>
      {/* begin::Row */}
      <div className='row mal50 g-5 g-xl-10 mb-5'>
        {/* begin::Col */}
        <div className='col-md-8 card'>
          <div id="kt_carousel_2_carousel" className="carousel carousel-custom slide" data-bs-ride="carousel">
            <div className="carousel-inner">
              {posts?.map((_value: any, index) => (
                <div key={index}
                  className={`carousel-item ${index === 0 ? 'active' : ''}`}>
                  <div className="row">
                    <div className="col-xl-7 col-xxl-7">
                      <img
                        src={_value.image}
                        alt={_value.title}
                        className="d-block w-100 img-carousel-home"
                        style={{ padding: '30px', borderRadius: '40px' }}
                      />
                    </div>
                    <div className="col-xl-5 col-xl-5 pleft40 pright30 cardnews">
                      <div className='ptop40' style={{ paddingRight: '20px' }}>
                        <span className="fw-bold text-gray-800 titlenews"
                          style={{ display: 'block', marginBottom: '15px' }}>
                          {/* Federación de Asociaciones Médicas de Salud Privada */}
                          {_value.title}
                        </span>
                        <span className='extracto'>
                          {/* La Federación espera ser un aporte en las actuales instancias de discusión sobre el futuro de la salud en el país. Busca contribuir en la elaboración de políticas */}
                          {_value.excerpt}
                        </span>

                        <Link to={`/noticias/view/${_value.slug}`}>
                          <button type='button' className='btn btn-primaryamsm me-3' style={{ marginTop: '20px', display: 'block' }}>
                            <span className='indicator-label'> Ver más </span>
                          </button>
                        </Link>

                      </div>
                    </div>
                  </div>
                </div>))}
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
              <div className="d-flex align-items-center justify-content-between flex-wrap">
                <ol className="p-0 m-0 carousel-indicators carousel-indicators-dots">
                  {posts?.map((_value, index) => (
                    <li data-bs-target="#kt_carousel_2_carousel"
                      data-bs-slide-to={index}
                      className={`ms-1 ${index === 0 ? 'active' : ''}`}
                      key={index}>
                    </li>
                  ))}
                </ol>
              </div>
            </div>
          </div>
        </div>
        <div className='col-md-4 fechapagos'>
          {/* <CardsWidget17 className='h-md-50 mb-5 mb-xl-10' /> */}
          <div className="card card-flush mal20 mar20" style={{ border: 'solid 1px #0067a5' }}>
            <div className='card-body' style={{ paddingBottom: '10px' }}>
              <div>
                <span className='fw-bold text-amsm text-fechas-proximo-pagos'>
                  Fechas próximos avisos de pagos
                  <img src={toAbsoluteUrl('/media/icons/7880066.png')} style={{ marginLeft: '10px', maxWidth: '24px' }} alt="..." />
                </span>
              </div>

              <div style={{ marginTop: '10px' }}>
                <span className='fw-bold text-gray-800 text-fechas-proximo-pagos'>
                  HMQ | {paymentDates.hmq}
                </span>
              </div>


              <div style={{ marginTop: '10px' }}>
                <span className='fw-bold text-gray-800 text-fechas-proximo-pagos'>
                  CONSULTAS | {paymentDates.consultas}
                </span>
              </div>


              <div style={{ marginTop: '10px' }}>
                {amount !== null && amount > 0 && !loadingAmount ? (
                  <>
                    <small>Tienes pagos disponibles
                      a tu disposición sin retirar</small>
                    <p className="text-center">
                      <Link to="/pagos/monto-no-retirado" className="btn btn-success me-2 w-100">
                        Ver pagos
                      </Link>
                    </p>
                  </>
                  // <p className="text-center"><a className="btn btn-outline-gray" role="button" href="/admin/pagos/monto-no-retirado">Ver pagos</a></p>
                ) : (
                  <p className="bg-light-primary text-primary p-3 fw-bold"
                    style={{ width: 'fit-content', paddingLeft: '10px !important', paddingRight: '10px !important' }}>
                    {loadingAmount ? 'Cargando Datos...' : 'No tienes pagos disponibles'}
                  </p>
                )}
              </div>
            </div>
          </div>
          <div className="card card-flush mal20 mar20" style={{ marginTop: '20px' }}>
            <Carousel controls={false} indicators={false}>
              {imagesBanner?.map((elem: any, index) => (
                <Carousel.Item key={index}>
                  <a href={elem.link} target='blank'>
                    <img className='d-block w-100' src={elem.image} alt='slide' />
                  </a>
                </Carousel.Item>
              ))}
            </Carousel>
          </div>
        </div>
      </div>


      {/* begin::Row */}
      <div className='row gy-5 g-xl-8 mal50 mar20'>
        <div className='col-lg-4 movil-pright0' style={{ paddingLeft: '0px' }}>
          {/* {amsmConecta?.amsmconecta?.link ? <a href={amsmConecta.amsmconecta.link} target='blank'>
            <img src={toAbsoluteUrl('/media/patterns/Banner_NL.png')}
              className="d-block w-100"
              style={{borderRadius: '8px'}}
              alt="..." />
          </a> : <>
          </>
          } */}
          <a href="/marketplace" target='blank'>
            <img src={toAbsoluteUrl('/media/patterns/marketplace.png')}
              className="d-block w-100"
              style={{borderRadius: '8px'}}
              alt="..." />
          </a>
        </div>
        <div className='col-lg-4 card borde-cumple' style={{ padding: '20px' }}>
          <div className='row'>
            <span className='fs-3 fw-bold text-amsm' >
              Próximos cumpleaños <img src={toAbsoluteUrl('/media/icons/2420548.png')} style={{ marginLeft: '10px', maxWidth: '32px' }} alt="..." />
            </span>
          </div>
          <div className="row" style={{ marginTop: '18px' }}>
            <div className='col-md-6'>
              {birthdays?.map((_value: any, index) => (
                <Birthday value={_value} show={((index + 1) % 2 === 1)} key={index} />
              ))}
            </div>
            <div className='col-md-6'>
              {birthdays?.map((_value: any, index) => (
                <Birthday value={_value} show={((index + 1) % 2 !== 1)} key={index} />
              ))}
            </div>
          </div>
        </div>
        <div className='col-lg-4 card borde-eventos' style={{ padding: '20px' }}>
          <div className='card-header proximos-eventos'>
            <span className='fs-3 fw-bold text-amsm' style={{}}>
              Próximos eventos <img src={toAbsoluteUrl('/media/icons/780677.png')} style={{ marginLeft: '10px', maxWidth: '32px' }} alt="..." />
            </span>
          </div>

          <div className="card-body" style={{ borderLeft: 'solid 1px rgb(0, 103, 165)' }}>
            {/* begin::Timeline */}
            <div className='timeline-label'>
              {events?.map((_value: any, index) => (
                <Event value={_value} key={index} />
              ))}
            </div>
            {/* end::Timeline */}
          </div>

        </div>
      </div>
      {/* end::Row */}

      {/* begin::Row */}
      <div className='row gy-5 g-xl-8 mal50 mar20' style={{ marginTop: '5px' }}>
        <div className='col' style={{ paddingLeft: '0px', marginTop: '10px' }}>
          <div className="card card-xl-stretch mb-xl-3">
            <div className="card-body link-dashboard pt-2" style={{ paddingLeft: '10px' }}>
              {/* begin::Item */}
              <div className='d-flex align-items-center'>
                {/* begin::Symbol */}
                <div className='symbol symbol-50px me-5'>
                  <span className='symbol-label bg-light-danger' style={{ border: 'solid 1px #f1416c' }}>
                    <KTIcon iconName='plus-square' className='fs-2x text-danger' />
                  </span>
                </div>
                {/* end::Symbol */}
                {/* begin::Text */}
                <div className='d-flex flex-column'>
                  {auth?.profesionalAsociado ? (
                    <Link to="/convenios" className="text-dark text-hover-primary botoninferior fw-bold">
                      Beneficios
                    </Link>
                  ) : (
                    <Link to="/hazte-socio" className="text-dark text-hover-primary botoninferior fw-bold">
                      Hazte Socio
                    </Link>
                  )}
                </div>
                {/* end::Text */}
              </div>
              {/* end::Item */}
            </div>
          </div>
        </div>
        <div className='col' style={{ paddingLeft: '0px', marginTop: '10px' }}>
          <div className="card card-xl-stretch mb-xl-3">
            <div className="card-body link-dashboard pt-2" style={{ paddingLeft: '10px' }}>
              {/* begin::Item */}
              <div className='d-flex align-items-center'>
                {/* begin::Symbol */}
                <div className='symbol symbol-50px me-5'>
                  <span className='symbol-label bg-light-success' style={{ border: 'solid 1px #50cd89' }}>
                    <KTIcon iconName='check-circle' className='fs-2x text-success' />
                  </span>
                </div>
                {/* end::Symbol */}
                {/* begin::Text */}
                <div className='d-flex flex-column'>
                  <Link to="/pago-prestaciones" className="text-dark text-hover-primary botoninferior fw-bold">
                    Pago Prestaciones
                  </Link>
                </div>
                {/* end::Text */}
              </div>
              {/* end::Item */}
            </div>
          </div>
        </div>
        <div className='col' style={{ paddingLeft: '0px', marginTop: '10px' }}>
          <div className="card card-xl-stretch mb-xl-3">
            <div className="card-body link-dashboard pt-2" style={{ paddingLeft: '10px' }}>
              {/* begin::Item */}
              <div className='d-flex align-items-center'>
                {/* begin::Symbol */}
                <div className='symbol symbol-50px me-5'>
                  <span className='symbol-label bg-light-info' style={{ border: 'solid 1px #7239ea' }}>
                    <KTIcon iconName='document' className='fs-2x text-info' />
                  </span>
                </div>
                {/* end::Symbol */}
                {/* begin::Text */}
                <div className='d-flex flex-column'>
                  <Link to="/formularios" className="text-dark text-hover-primary botoninferior fw-bold">
                    Formularios
                  </Link>
                </div>
                {/* end::Text */}
              </div>
              {/* end::Item */}
            </div>
          </div>
        </div>
        <div className='col' style={{ paddingLeft: '0px', marginTop: '10px' }}>
          <div className="card card-xl-stretch mb-xl-3">
            <div className="card-body link-dashboard pt-2" style={{ paddingLeft: '10px' }}>
              {/* begin::Item */}
              <div className='d-flex align-items-center'>
                {/* begin::Symbol */}
                <div className='symbol symbol-50px me-5'>
                  <span className='symbol-label bg-light-warning' style={{ border: 'solid 1px #ffc700' }}>
                    <KTIcon iconName='book' className='fs-2x text-warning' />
                  </span>
                </div>
                {/* end::Symbol */}
                {/* begin::Text */}
                <div className='d-flex flex-column'>
                  <a href='https://www.clinicasantamaria.cl/informate/newsletter' target="blank" className='text-dark text-hover-primary botoninferior fw-bold'>
                    Newsletter Clínica
                  </a>
                </div>
                {/* end::Text */}
              </div>
              {/* end::Item */}
            </div>
          </div>
        </div>
        <div className='col' style={{ paddingLeft: '0px', marginTop: '10px' }}>
          <div className="card card-xl-stretch mb-xl-3">
            <div className="card-body link-dashboard pt-2" style={{ paddingLeft: '10px' }}>
              {/* begin::Item */}
              <div className='d-flex align-items-center'>
                {/* begin::Symbol */}
                <div className='symbol symbol-50px me-5'>
                  <span className='symbol-label bg-naranja border-naranja'>
                    <KTIcon iconName='book' className='fs-2x text-naranja' />
                  </span>
                </div>
                {/* end::Symbol */}
                {/* begin::Text */}
                <div className='d-flex flex-column'>
                  <a href={newsletterFederacion?.newsletter_federacion?.link ? newsletterFederacion.newsletter_federacion.link : ''} target="blank" className='text-dark text-hover-primary botoninferior fw-bold'>
                    Newsletter Federación
                  </a>
                </div>
                {/* end::Text */}
              </div>
              {/* end::Item */}
            </div>
          </div>
        </div>
        <div className='col' style={{ paddingLeft: '0px', marginTop: '10px' }}>
          <div className="card card-xl-stretch mb-xl-3">
            <div className="card-body link-dashboard pt-2" style={{ paddingLeft: '10px' }}>
              {/* begin::Item */}
              <div className='d-flex align-items-center'>
                {/* begin::Symbol */}
                <div className='symbol symbol-50px me-5'>
                  <span className='symbol-label bg-light-primary' style={{ border: 'solid 1px #0092f7' }}>
                    <KTIcon iconName='question-2' className='fs-2x text-primary' />
                  </span>
                </div>
                {/* end::Symbol */}
                {/* begin::Text */}
                <div className='d-flex flex-column'>
                  <Link to="/preguntas-frecuentes" className='text-dark text-hover-primary botoninferior fw-bold'>
                    Preguntas Frecuentes
                  </Link>
                </div>
                {/* end::Text */}
              </div>
              {/* end::Item */}
            </div>
          </div>
        </div>
      </div>
      {/* end::Row */}
    </>
  )
}

const DashboardWrapper: FC = () => {
  // const intl = useIntl()

  useEffect(() => {
    setTitlePage('Inicio');
  }, [])

  return (
    <>
      {/* <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.DASHBOARD'})}</PageTitle> */}
      <DashboardPage />
    </>
  )
}

export { DashboardWrapper }
